import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorage } from '../services/token.service';
const TOKEN_HEADER_KEY = 'Authorization';
const deviceTimeZone = new Date().toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'long' }).substring(4)

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  position: any
  publicIpAddr: any;
  deviceIpAddrs: any;
  constructor(private token: TokenStorage,
  ) {

  }
  async getIPAddress() {
    try {
      const response = await fetch(environment.ipifyUrl);
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP address:', error);
      return null;
    }
  }
  async goToGetIPAddress() {
    const ipAddress = await this.getIPAddress();
    return ipAddress;

  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
   // const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    let lang = '';
    let userSettings = window.localStorage.getItem('userSettings');
    if (userSettings) {
      let userSettingParsed = JSON.parse(userSettings);
      lang = userSettingParsed.lang;
    } else {
      lang = 'en'
    }
    //Changed by Abirami on 11th May 2023 - They removed the validation for client info and fingerprint at backend 
    //IP Address fetch is taking time and finger print should be licensed version if we are using
    let clientInfo = {
      "deviceID": "RFzuSZGSmX0cpYW8PAJb",
      "deviceID2": "RFzuSZGSmX0cpYW8PAJb",
      "deviceTimeZone": "India Standard Time",
      "deviceIpAddress": "103.82.210.58",
      "deviceLatitude": 12.686,
      "deviceLongitude": 77.8637,
      "deviceType": "desktop",
      "deviceModel": "Windows",
      "deviceVersion": "windows-10",
      "deviceUserID": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35",
      "deviceAppVersion": "1.0.8",
      "deviceIsJailBroken": false,
      "language": lang

    }
    if (this.token.get()) {
      const headers = req.headers
      .set(TOKEN_HEADER_KEY, 'Bearer ' + this.token.get());
        // .set('fingerprint', "RFzuSZGSmX0cpYW8PAJb") //This is currently not in use and commented on 30th March by Abirami
        // .append('clientInfo', JSON.stringify(clientInfo))
        //.append(TOKEN_HEADER_KEY, 'Bearer ' + this.token.get());
      const requestClone = req.clone({
        headers,
      });
      return next.handle(requestClone);
    } 
    // else if (this.token.getCT()) {
    //   const headers = req.headers
    //   .set(TOKEN_HEADER_KEY, 'Bearer ' + this.token.getCT());
    //     // .set('fingerprint', "RFzuSZGSmX0cpYW8PAJb") //This is currently not in use and commented on 30th March by Abirami
    //     // .append('clientInfo', JSON.stringify(clientInfo))
    //     //.append(TOKEN_HEADER_KEY, 'Bearer ' + this.token.get());
    //   const requestClone = req.clone({
    //     headers,
    //   });
    //   return next.handle(requestClone);
    // } 
    else {
      // const headers = req.headers
      //   .set('fingerprint', "RFzuSZGSmX0cpYW8PAJb")
      //   .append('clientInfo', JSON.stringify(clientInfo)) //This is currently not in use and commented on 30th March by Abirami
      const requestClone = req.clone({});
      return next.handle(requestClone);
    }
  }
}